export default __webpack_public_path__ + "static/about-us-hero-2700eedd2609aa120661fb78d065066a.mp4";